import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  QuickFactValue,
  mappings,
  VALUE_SIZES,
} from '@nerdwallet/react-quick-facts';
import nds from '@nerdwallet/base-styles/classes';

const EditableQuickFacts = ({ marketplaceEntity, quickFactName }) => {
  const productType = _.camelCase(_.get(marketplaceEntity, 'product_type'));

  const quickFactMapping = _.get(
    mappings,
    `${productType}.${quickFactName}`,
    () => ({})
  )(marketplaceEntity);

  return (
    <div
      className={nds('text-align-center')}
      data-integration="editable-quick-facts"
    >
      <QuickFactValue
        quickFact={{
          ...quickFactMapping,
          valueSize: VALUE_SIZES.LARGE,
        }}
        showNAForEmptyValue
      />
    </div>
  );
};

EditableQuickFacts.propTypes = {
  marketplaceEntity: PropTypes.object,
  quickFactName: PropTypes.string,
};

EditableQuickFacts.defaultProps = {
  marketplaceEntity: {},
};

export default EditableQuickFacts;
